import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../../../App";
import { MultiSelect } from "../../../../../controls";
import { action, API, controller } from "../../../../../api/api";
import { Dialog } from "../../../../../layout";
import AddSplrForm from "./AddSplrForm";

const InputSupplier = ({ values, setValues, handleInpChg, size = "small" }) => {
  const { authUser } = useContext(AppContext);

  const [splrs, setSplrs] = useState([]);
  const [newAddingValue, setNewAddingValue] = useState("");
  const [showSplrForm, setShowSplrForm] = useState(false);

  // Get Suppliers
  useEffect(() => {
    if (authUser.id) {
      API(controller.Supplier + action.GetAllByOrg).get((res) => {
        res.status === 200 &&
          setSplrs([...res.result.map((j) => ({ ...j, label: j.splrName }))]);
      });
    }
    return () => {};
  }, [authUser]);

  const handleAddNewSplr = (val) => {
    setNewAddingValue(val);
    setShowSplrForm(!showSplrForm);
  };

  const handleNewSplr = (val) => {
    if (val) {
      setSplrs([{ ...val, label: val.splrName }, ...splrs]);
      setValues((j) => ({
        ...j,
        prodSuppliers: [...j.prodSuppliers, val.id],
        markup: val.defMarkup,
      }));
      setNewAddingValue("");
      setShowSplrForm(!showSplrForm);
    }
  };

  const handleSplrInput = (e) => {
    handleInpChg(e);
    var splrDtls = splrs.find((j) => j.id === e.target.value);
    splrDtls && setValues((j) => ({ ...j, markup: splrDtls.defMarkup }));
  };

  return (
    <>
      <MultiSelect
        label="Suppliers"
        name="prodSuppliers"
        value={values.prodSuppliers}
        onChange={handleSplrInput}
        options={splrs}
        enableAddBtn={true}
        handleAdd={handleAddNewSplr}
        size={size}
      />

      {/* Add new supplier */}
      {showSplrForm && (
        <Dialog show={showSplrForm} onClose={false} maxWidth="xs">
          <AddSplrForm
            {...{
              setShowForm: setShowSplrForm,
              splrName: newAddingValue,
              handleResult: handleNewSplr,
            }}
          />
        </Dialog>
      )}
    </>
  );
};

export default InputSupplier;
